/* eslint-disable react/require-default-props, jsx-a11y/label-has-associated-control */

import React from 'react';
import SubtitleRegular from 'components/Typography/SubtitleRegular';

import type { ComponentProps } from 'react';

import './index.scss';

type CheckboxProps = ComponentProps<'input'> & {
  label?: string;
};

export default function Checkbox({
  label = '',
  disabled = false,
  className = '',
  ...otherProps
}: CheckboxProps) {
  return (
    <label className={`ds-checkbox-container ${className} ${disabled ? 'disabled' : ''}`}>
      <input
        type="checkbox"
        disabled={disabled}
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...otherProps}
      />
      <span className="checkmark" />
      <SubtitleRegular>{label}</SubtitleRegular>
    </label>
  );
}
